import { z } from "zod";

export const ChangeRoomConditionSchema = z.object({
    room_condition: z.string(),
    user_id: z.nullable(z.string()).optional(),
})

export type ChangeRoomConditionSchemaType = z.infer<typeof ChangeRoomConditionSchema>